<template>
  <!-- 设备维护弹窗 -->
  <a-modal
    :title="`设备维护 - ${equipmentName || ''}`"
    :visible="visible"
    @cancel="handleClose"
    :width="1200"
    :footer="null"
  >
    <!-- 条件搜索区域 -->
    <div class="table-page-search-wrapper" style="margin-bottom: 16px">
      <a-form layout="inline">
        <a-row :gutter="[16, 8]">
          <!-- 设备名称筛选 -->
          <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
            <a-form-item label="设备名称">
              <a-input
                v-model:value="queryParam.name"
                placeholder="请输入设备名称"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <!-- 故障现象筛选 -->
          <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
            <a-form-item label="故障现象">
              <a-input
                v-model:value="queryParam.malfunctionSymptoms"
                placeholder="请输入故障现象"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>
          <!-- 故障原因筛选 -->
          <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
            <a-form-item label="故障原因">
              <a-input
                v-model:value="queryParam.causeOfFailure"
                placeholder="请输入故障原因"
                allow-clear
                class="no-border-radius-input"
              />
            </a-form-item>
          </a-col>

          <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
          <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
            <a-form-item>
              <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                <a-button type="primary" @click="handleQuery" class="search-button">查询</a-button>
                <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button">重置</a-button>
                <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                  {{ advanced ? '收起' : '展开' }}
                  <UpOutlined v-if="advanced" />
                  <DownOutlined v-else />
                </a-button>
              </span>
            </a-form-item>
          </a-col>

          <!-- 高级搜索条件（展开后显示） -->
          <template v-if="advanced">
            <!-- 维修费用筛选 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="维修费用">
                <a-input-number
                  v-model:value="queryParam.price"
                  :min="0"
                  :step="0.01"
                  :precision="2"
                  placeholder="请输入维修费用"
                  style="width: 100%"
                  class="no-border-radius-input-number"
                />
              </a-form-item>
            </a-col>
            <!-- 维保状态筛选 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="维保状态">
                <a-select
                  v-model:value="queryParam.maintenanceStatus"
                  placeholder="请选择维保状态"
                  allow-clear
                  style="width: 100%"
                  class="no-border-radius-select"
                >
                  <a-select-option v-for="(d, index) in dict.type['maintenance_status']" :key="index" :value="d.value">
                    {{ d.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 维修物流信息筛选 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="维修物流信息">
                <a-input
                  v-model:value="queryParam.logisticsInformation"
                  placeholder="请输入维修物流信息"
                  allow-clear
                  class="no-border-radius-input"
                />
              </a-form-item>
            </a-col>
            <!-- 时间筛选 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item label="时间">
                <a-date-picker
                  v-model:value="queryParam.operationTime"
                  style="width: 100%"
                  format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD"
                  placeholder="请选择时间"
                  allow-clear
                  class="no-border-radius-picker"
                />
              </a-form-item>
            </a-col>

            <!-- 展开后，按钮在最后一行 -->
            <a-col :xxl="6" :xl="8" :lg="8" :md="8" :sm="24" :xs="8">
              <a-form-item>
                <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                  <a-button type="primary" @click="handleQuery" class="search-button">查询</a-button>
                  <a-button style="margin-left: 8px" @click="handleReset" class="no-border-button">重置</a-button>
                  <a-button style="margin-left: 8px" @click="toggleAdvanced" class="no-border-button toggle-button">
                    {{ advanced ? '收起' : '展开' }}
                    <UpOutlined v-if="advanced" />
                    <DownOutlined v-else />
                  </a-button>
                </span>
              </a-form-item>
            </a-col>
          </template>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operations" style="margin-bottom: 16px">
      <a-button
        type="text"
        shape="circle"
        @click="handleRefresh"
        v-hasPermi="refreshPermission"
        class="refresh-icon-button"
      >
        <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
      </a-button>
      <a-button type="primary" @click="handleAdd" v-hasPermi="addPermission" class="add-button">
        <PlusOutlined />新增
      </a-button>
      <a-button
        @click="handleExport"
        :disabled="!list || list.length === 0 || pagination.total === 0"
        v-hasPermi="exportPermission"
        class="no-border-button"
      >
        <UploadOutlined />导出
      </a-button>
      <a-button
        :disabled="!selectedRowKeys || selectedRowKeys.length === 0"
        @click="handleDelete"
        v-hasPermi="removePermission"
        class="no-border-button delete-button"
      >
        <DeleteOutlined />删除
      </a-button>
    </div>
    <!-- 增加修改表单 -->
    <create-form ref="createForm" :equipment-id="equipmentId" :equipment-name="equipmentName" @ok="getList" />
    <!-- 数据表格 -->
    <div v-if="list && list.length > 0">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :scroll="{ x: 'max-content' }"
        rowKey="id"
        size="small"
        class="optimized-table"
        @change="handleTableChange"
      >
        <!-- 使用 bodyCell 插槽自定义单元格显示 -->
        <template #bodyCell="{ column, text, record, index }">
          <!-- 序号列：根据分页计算序号 -->
          <template v-if="column.dataIndex === 'id'">
            <span>
              {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
            </span>
          </template>
          <!-- 维保状态：显示对应文字 -->
          <template v-else-if="column.dataIndex === 'maintenanceStatus'">
            <span>{{
              text == 1 || text == '1'
                ? '维保中'
                : text == 0 || text == '0'
                ? '待维保'
                : text == 2 || text == '2'
                ? '维保结束'
                : text
            }}</span>
          </template>
          <!-- 设备名称列：显示设备名称，如果记录中没有则使用props传入的设备名称 -->
          <template v-else-if="column.dataIndex === 'name'">
            <span>
              {{ record.name || equipmentName || '-' }}
            </span>
          </template>
          <!-- 时间列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'operationTime'">
            <span>
              {{ parseTime(record.operationTime) }}
            </span>
          </template>
          <!-- 维修费用列：格式化显示 -->
          <template v-else-if="column.dataIndex === 'price'">
            <span>
              {{ record.price ? `¥${record.price}` : '-' }}
            </span>
          </template>
          <!-- 操作列：编辑、删除 -->
          <template v-else-if="column.dataIndex === 'action'">
            <span>
              <a-divider type="vertical" v-hasPermi="editPermission" />
              <a @click="handleEdit(record)" v-hasPermi="editPermission" style="margin-right: 8px"> 编辑 </a>
              <a-divider type="vertical" v-hasPermi="removePermission" />
              <a @click="handleDelete(record)" v-hasPermi="removePermission" class="delete-link"> 删除 </a>
            </span>
          </template>
        </template>
      </a-table>
    </div>
    <!-- 空数据提示 -->
    <a-empty v-else description="暂无设备维护数据" style="padding: 60px 0" />
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
/**
 * 设备维护组件
 * 功能：显示指定设备的维护记录
 * - 支持按设备名称、时间、故障现象、维保状态筛选维护记录
 * - 支持分页查询和刷新
 * - 支持新增、编辑、删除维护记录
 * - 支持导出维护记录数据
 * - 通过props接收设备ID和名称
 */
import { PlusOutlined, UploadOutlined, DeleteOutlined, UpOutlined, DownOutlined } from '@ant-design/icons-vue'
import { pageEquipmentMaintenance, delEquipmentMaintenance } from '@/api/system/equipmentMaintenance'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './EquipmentMaintenanceCreateForm'

export default {
  name: 'EquipmentMaintenance',
  // 字典类型配置
  dicts: ['maintenance_status'],
  mixins: [tableMixin],
  components: {
    CreateForm,
    PlusOutlined,
    UploadOutlined,
    DeleteOutlined,
    UpOutlined,
    DownOutlined,
  },
  props: {
    // 弹窗显示/隐藏状态
    visible: {
      type: Boolean,
      default: false,
    },
    // 设备ID（必填）
    equipmentId: {
      type: Number,
      default: null,
    },
    // 设备名称（用于显示在标题中）
    equipmentName: {
      type: String,
      default: '',
    },
    // 权限前缀，用于动态生成权限值
    permissionPrefix: {
      type: String,
      default: 'system:equipmentMaintenance',
    },
  },
  data() {
    return {
      // 维护记录列表数据
      list: [],
      // 加载状态
      loading: false,
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 初始化标志，防止重复请求
      isInitializing: false,
      // 高级搜索展开/关闭状态
      advanced: false,
      // 查询参数（维护ID不在搜索条件中显示，默认使用传入的设备ID）
      // 按照表格列顺序排列
      queryParam: {
        name: undefined, // 设备名称
        malfunctionSymptoms: undefined, // 故障现象
        causeOfFailure: undefined, // 故障原因
        price: undefined, // 维修费用
        maintenanceStatus: undefined, // 维保状态
        logisticsInformation: undefined, // 维修物流信息
        operationTime: null, // 操作时间
      },
      // 分页配置
      pagination: {
        current: 1, // 当前页码
        pageSize: 10, // 每页条数
        total: 0, // 总条数
        showSizeChanger: true, // 显示每页条数选择器
        showQuickJumper: true, // 显示快速跳转
        showTotal: (total) => `共 ${total} 条`, // 显示总数
      },
      // 表格列配置
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
          width: 80,
        },
        {
          title: '设备名称',
          dataIndex: 'name',
          align: 'center',
          width: 150,
        },
        {
          title: '故障现象',
          dataIndex: 'malfunctionSymptoms',
          align: 'center',
          width: 200,
        },
        {
          title: '故障原因',
          dataIndex: 'causeOfFailure',
          align: 'center',
          width: 200,
        },
        {
          title: '维修费用',
          dataIndex: 'price',
          align: 'center',
          width: 120,
        },
        {
          title: '维保状态',
          dataIndex: 'maintenanceStatus',
          align: 'center',
          width: 120,
        },
        {
          title: '维修物流信息',
          dataIndex: 'logisticsInformation',
          align: 'center',
          width: 200,
        },
        {
          title: '时间',
          dataIndex: 'operationTime',
          align: 'center',
          width: 180,
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 150,
          fixed: 'right',
        },
      ],
    }
  },
  computed: {
    submitButtonStyle() {
      return {}
    },
    /**
     * 新增权限
     * 根据权限前缀动态生成新增权限值
     */
    addPermission() {
      return [`${this.permissionPrefix}:add`]
    },
    /**
     * 编辑权限
     * 根据权限前缀动态生成编辑权限值
     */
    editPermission() {
      return [`${this.permissionPrefix}:edit`]
    },
    /**
     * 删除权限
     * 根据权限前缀动态生成删除权限值
     */
    removePermission() {
      return [`${this.permissionPrefix}:remove`]
    },
    /**
     * 导出权限
     * 根据权限前缀动态生成导出权限值
     */
    exportPermission() {
      return [`${this.permissionPrefix}:export`]
    },
    /**
     * 刷新权限
     * 根据权限前缀动态生成刷新权限值
     */
    refreshPermission() {
      return [`${this.permissionPrefix}:refresh`]
    },
  },
  watch: {
    /**
     * 监听弹窗显示状态
     * 当弹窗打开且设备ID存在时，初始化数据
     */
    visible(newVal) {
      if (newVal && this.equipmentId) {
        this.$nextTick(() => {
          if (!this.isInitializing) {
            this.init()
          }
        })
      } else if (!newVal) {
        // 弹窗关闭时重置初始化标志
        this.isInitializing = false
      }
    },
    /**
     * 监听设备ID变化
     * 当设备ID变化且弹窗打开时，重新初始化数据
     */
    equipmentId(newVal, oldVal) {
      // 只有当设备ID真正变化（从无到有，或从一个值变为另一个值）且弹窗打开时才初始化
      if (newVal && newVal !== oldVal && this.visible) {
        this.$nextTick(() => {
          if (!this.isInitializing) {
            this.init()
          }
        })
      }
    },
  },
  methods: {
    /**
     * 初始化数据
     * 重置分页、清空列表、重置查询条件，然后获取维护记录列表
     */
    init() {
      // 防止重复初始化
      if (this.isInitializing) {
        return
      }
      this.isInitializing = true

      // 重置分页到第一页
      this.pagination.current = 1
      this.pagination.total = 0
      // 清空列表数据
      this.list = []
      // 清空选中状态
      this.selectedRowKeys = []
      this.selectedRows = []
      // 重置查询条件（按照表格列顺序）
      this.queryParam = {
        name: undefined, // 设备名称
        malfunctionSymptoms: undefined, // 故障现象
        causeOfFailure: undefined, // 故障原因
        price: undefined, // 维修费用
        maintenanceStatus: undefined, // 维保状态
        logisticsInformation: undefined, // 维修物流信息
        operationTime: null, // 操作时间
      }
      // 获取维护记录列表
      this.getList().finally(() => {
        // 请求完成后重置标志
        this.isInitializing = false
      })
    },

    /**
     * 获取设备维护记录列表
     * 根据设备ID（作为maintenanceId）和查询条件分页查询维护记录数据
     * @returns {Promise} 返回请求的 Promise
     */
    getList() {
      // 校验设备ID
      if (!this.equipmentId) {
        this.$message.warning('设备ID不能为空', 3)
        return Promise.resolve()
      }

      // 开始加载
      this.loading = true

      // 构建请求参数（按照表格列顺序）
      const params = {
        maintenanceId: this.equipmentId, // 维护ID（默认使用传入的设备ID）
        name: this.queryParam.name, // 设备名称
        malfunctionSymptoms: this.queryParam.malfunctionSymptoms, // 故障现象
        causeOfFailure: this.queryParam.causeOfFailure, // 故障原因
        price: this.queryParam.price, // 维修费用
        maintenanceStatus: this.queryParam.maintenanceStatus, // 维保状态
        logisticsInformation: this.queryParam.logisticsInformation, // 维修物流信息
        operationTime: this.queryParam.operationTime, // 操作时间
        pageNum: this.pagination.current, // 当前页码
        pageSize: this.pagination.pageSize, // 每页条数
      }

      // 移除空值参数，避免传递无效参数
      Object.keys(params).forEach((key) => {
        if (params[key] === undefined || params[key] === null || params[key] === '') {
          delete params[key]
        }
      })

      // 发送请求并返回 Promise
      return pageEquipmentMaintenance(params)
        .then((response) => {
          // 设置列表数据和总数
          this.list = response.data.records || []
          this.pagination.total = response.data.total || 0
          this.loading = false
        })
        .catch(() => {
          // 请求失败，清空数据
          this.loading = false
          this.list = []
          this.pagination.total = 0
        })
    },

    /**
     * 查询操作
     * 重置到第一页并重新获取列表
     */
    handleQuery() {
      this.pagination.current = 1
      this.getList()
    },

    /**
     * 重置查询条件
     * 清空所有查询条件，重置到第一页并重新获取列表
     */
    handleReset() {
      // 重置查询条件（按照表格列顺序）
      this.queryParam = {
        name: undefined, // 设备名称
        malfunctionSymptoms: undefined, // 故障现象
        causeOfFailure: undefined, // 故障原因
        price: undefined, // 维修费用
        maintenanceStatus: undefined, // 维保状态
        logisticsInformation: undefined, // 维修物流信息
        operationTime: null, // 操作时间
      }
      // 重置到第一页
      this.pagination.current = 1
      // 重新获取列表
      this.getList()
    },

    /**
     * 刷新列表
     * 重新获取当前条件下的维护记录列表
     */
    handleRefresh() {
      this.getList()
    },

    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 新增维护记录
     * 打开新增表单，默认填充设备ID和设备名称
     * 设备类型会自动填充为"设备维护"并禁用
     */
    handleAdd() {
      if (!this.equipmentId) {
        this.$message.warning('设备ID不能为空', 3)
        return
      }
      // 传入设备ID和设备名称，CreateForm会自动设置设备类型为"设备维护"并禁用
      this.$refs.createForm.handleAdd(this.equipmentId, this.equipmentName)
    },

    /**
     * 编辑维护记录
     * 打开编辑表单，填充当前记录数据
     * @param {Object} record - 当前行记录
     */
    handleEdit(record) {
      this.$refs.createForm.handleUpdate(record)
    },

    /**
     * 删除维护记录
     * 支持批量删除和单条删除
     * @param {Object} record - 可选，如果传入则删除单条记录，否则删除选中的多条记录
     */
    handleDelete(record) {
      const that = this
      // 如果传入了record参数，则是单条删除
      if (record) {
        this.$confirm({
          title: '确认删除这条记录?',
          content: `确定要删除这条维护记录吗？`,
          onOk() {
            const data = [{ id: record.id }]
            return delEquipmentMaintenance(data)
              .then(() => {
                that.getList()
                that.$message.success('删除成功', 3)
              })
              .catch(() => {
                that.$message.error('删除失败', 3)
              })
          },
          onCancel() {
            // 取消时不做任何操作
          },
        })
        return
      }
      // 否则是批量删除
      const ids = this.selectedRowKeys
      if (!ids || ids.length === 0) {
        this.$message.warning('请选择要删除的记录', 3)
        return
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: `当前选中 ${ids.length} 条数据`,
        onOk() {
          const data = ids.map((id) => ({ id: id }))
          return delEquipmentMaintenance(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
            .catch(() => {
              that.$message.error('删除失败', 3)
            })
        },
        onCancel() {
          // 取消时不做任何操作
        },
      })
    },

    /**
     * 删除维护记录（单条）
     * 删除单条记录
     * @param {Object} record - 当前行记录
     */
    handleDeleteSingle(record) {
      const that = this
      const data = [{ id: record.id }]
      delEquipmentMaintenance(data)
        .then(() => {
          that.getList()
          that.$message.success('删除成功', 3)
        })
        .catch(() => {
          that.$message.error('删除失败', 3)
        })
    },

    /**
     * 导出维护记录数据
     * 支持导出选中数据或当前查询条件下的全部数据
     * - 如果选中了数据，则只导出选中的数据
     * - 如果没有选中数据，则导出当前查询条件下的全部数据
     */
    handleExport() {
      const that = this
      const hasSelection = that.selectedRowKeys && that.selectedRowKeys.length > 0
      // 确认对话框
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk() {
          // 构建导出参数（按照表格列顺序）
          const params = {
            maintenanceId: that.equipmentId,
            name: that.queryParam.name,
            malfunctionSymptoms: that.queryParam.malfunctionSymptoms,
            causeOfFailure: that.queryParam.causeOfFailure,
            price: that.queryParam.price,
            maintenanceStatus: that.queryParam.maintenanceStatus,
            logisticsInformation: that.queryParam.logisticsInformation,
            operationTime: that.queryParam.operationTime,
          }
          // 如果选中了数据，则传递maintenanceIds参数
          if (hasSelection) {
            params.maintenanceIds = that.selectedRowKeys
          }
          // 移除空值参数（maintenanceIds 数组不会被删除）
          Object.keys(params).forEach((key) => {
            if (params[key] === undefined || params[key] === null || params[key] === '') {
              delete params[key]
            }
          })
          // 下载文件
          that.download(
            'system/equipment-maintenance/export',
            params,
            `设备维护_${that.equipmentName || ''}_${new Date().getTime()}.xls`
          )
        },
        onCancel() {},
      })
    },

    /**
     * 多选变化处理
     * 更新选中的行key和行数据
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

    /**
     * 关闭弹窗
     * 触发close事件，通知父组件关闭弹窗
     */
    handleClose() {
      $emit(this, 'close')
    },

    /**
     * 表格变化处理
     * 处理分页变化（页码、每页条数）
     * @param {Object} pagination - 分页对象
     */
    handleTableChange(pagination) {
      // 更新分页信息
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 分页变化时清空选择
      this.onSelectChange([], [])
      // 重新获取列表
      this.getList()
    },
  },
  emits: ['close'],
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 80px;
  text-align: right;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input) {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  background: #ffffff !important;
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
}

.table-page-search-wrapper :deep(.ant-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
  background: #ffffff !important;
}

.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number) {
  border-radius: 4px !important;
  border: 1px solid #c7c7c7 !important;
  background: #ffffff !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 删除按钮样式 - 参照 projectUser 页面的修改状态按钮 */
.delete-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.delete-button:hover,
.delete-button:focus {
  color: #333333 !important;
}

.delete-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

/* 展开/收起按钮文字和图标颜色 */
.toggle-button {
  color: #165dff !important;
  background-color: transparent !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px;
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 1;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 2;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 操作列链接样式 */
.optimized-table :deep(.ant-table-tbody > tr > td a) {
  color: #165dff !important;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
}

.optimized-table :deep(.ant-table-tbody > tr > td a:hover) {
  color: #4080ff !important;
}

/* 删除按钮红色样式 */
.optimized-table :deep(.ant-table-tbody > tr > td a.delete-link) {
  color: #ff4d4f !important;
}

.optimized-table :deep(.ant-table-tbody > tr > td a.delete-link:hover) {
  color: #ff7875 !important;
}

/* 表格分页样式 */
.optimized-table :deep(.ant-pagination) {
  margin-top: 16px;
}

.optimized-table :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.optimized-table :deep(.ant-pagination-prev),
.optimized-table :deep(.ant-pagination-next),
.optimized-table :deep(.ant-pagination-prev .ant-pagination-item-link),
.optimized-table :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.optimized-table :deep(.ant-pagination-prev button),
.optimized-table :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.optimized-table :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.optimized-table :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.optimized-table :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}
</style>
